__turbopack_context__.v({
  "drawer": "ProfileFieldActionDrawer-module__WIWP8a__drawer",
  "root": "ProfileFieldActionDrawer-module__WIWP8a__root",
});
